<p-dialog header="" [visible]="visible" styleClass="w-vw-16 lg:w-[756px]" [draggable]="false" (onHide)="onCloseDialog()" (visibleChange)="onVisibleChange($event)"
  [modal]="true" class="login-modal">
<div class="login-form">
  <div class=" w-auto  mx-auto flex flex-col items-center">
    <div class="w-[180px] p-1 bg-[#F2F2F2] rounded-[80px]">
      <div class="tab-container" [ngClass]="{'active-register': isRegisterActive}">
        <div class="tab font-medium text-[14px] ml-1" [ngClass]="{'active': !isRegisterActive}" (click)="activateLogin()">Login</div>
        <div class="tab font-medium text-[14px] ml-1" [ngClass]="{'active': isRegisterActive}" (click)="activateRegister()">Register</div>
        <div class="tab-background"></div>
      </div>
    </div>
    <div *ngIf="!isRegisterActive" class="mt-8 lg:mt-10 lg:w-[430px]">
      <div>
        <div *ngIf="loginAction !== 'Sitetour'" class="text-center text-[18px] lg:text-[24px] font-NewSpirit text-black">{{'login-form.header-label' | translate}}</div>

        <div *ngIf="loginAction === 'Sitetour'" class="text-center text-[18px] lg:text-[24px] font-NewSpirit text-black">{{'sitetour-login-form.header-label' | translate}}</div>
      
        <div *ngIf="!isUsingExternalIdentityServer">
          <app-xn-form [fields]="loginFields" #loginForm [submitted]="isLoginFormSubmitted"></app-xn-form>
          <div class="mt-6 text-center">
            <button class="btn btn-primary w-[180px]" [disabled]="!loginForm.isValid()" (click)="login()">LOGIN</button>
          </div>
        </div>
      
        <div *ngIf="isUsingExternalIdentityServer" class="text-center mt-8 lg:mt-10">
          <button class="btn btn-primary w-full lg:w-auto" (click)="loginWithIDP()">Login</button>
        </div>
      
      </div>
    </div>
    <div *ngIf="isRegisterActive" styleClass="p-0 lg:p-[1.25rem]" class="mt-8">
      <div>
        <div class="text-center text-[18px] lg:text-[24px] font-NewSpirit text-black">Please fill out the information below to
          complete your booking.</div>

        <div class="mt-8">
          <app-xn-form [fields]="registerFields" #registerForm [submitted]="isSubmittedRegisterForm"></app-xn-form>
        </div>
        
        <div class="mt-8 lg:mt-10 text-center">
          <button class="btn btn-primary w-full lg:w-[180px]" [disabled]="!registerForm.isValid()"
            (click)="register(registerForm)">Register</button>
        </div>
      </div>
    </div>
  </div>
</div>
</p-dialog>